export default __webpack_public_path__ + "static/img_2_0-86bad621f09cc227185cf944b2abae48.jpg";